import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components';
import {
  HomePage,
  SinglePostPage,
  AdminPage,
  AdminEditPage,
  AdminNewPage,
  SearchPage,
} from './pages';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/post/:id" element={<SinglePostPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/new" element={<AdminNewPage />} />
          <Route path="/admin/edit/:id" element={<AdminEditPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
